export default {
      id: "icon-chevron-usage",
      viewBox: "0 0 28 28",
      url: "../icon/" + "icons.svg#icon-chevron-usage",
      toString: function () {
        return this.url;
      }
    }